module.exports = __webpack_public_path__ + "img/quick-books-empty-state.a3c2662b.svg";